import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=2a197c78"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=2a197c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports